import { useTranslation } from 'react-i18next';
import NumberFlow from '@number-flow/react';

export const OrderFormNumberOfItems = ({ numberOfItems }: { numberOfItems: number }) => {
  const { t } = useTranslation();

  return (
    <div className="inline-flex gap-1 text-right align-baseline text-sm text-gray-700">
      <NumberFlow value={numberOfItems} />
      <span>{t('orderForms:form.header.itemCount', { count: numberOfItems })}</span>
    </div>
  );
};
